import { render, staticRenderFns } from "./viewPlanDetails.vue?vue&type=template&id=4549f16a"
import script from "./viewPlanDetails.vue?vue&type=script&lang=js"
export * from "./viewPlanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports